import { INVENTORY_STATE } from '@jazel-auto/ise-contracts/dist/inventory.js'
import type { InventoryState } from '@/services/inventory'

export type ManualInventoryStateOption = {
  title: string
  value: InventoryState
}

export function buildManualInventoryStateOptions(options: {
  includeReadyCourtesy: boolean
  includeArchived?: boolean
}): ManualInventoryStateOption[] {
  return [
    { title: 'On order', value: INVENTORY_STATE.ON_ORDER },
    { title: 'In production', value: INVENTORY_STATE.IN_PRODUCTION },
    { title: 'In transit', value: INVENTORY_STATE.IN_TRANSIT },
    { title: 'Ready for sale', value: INVENTORY_STATE.READY_FOR_SALE },
    ...(options.includeReadyCourtesy
      ? [{ title: 'Ready Courtesy', value: INVENTORY_STATE.READY_COURTESY }]
      : []),
    { title: 'In service', value: INVENTORY_STATE.IN_SERVICE },
    { title: 'Unknown', value: INVENTORY_STATE.UNKNOWN },
    { title: 'Reserved', value: INVENTORY_STATE.RESERVED },
    { title: 'Sold', value: INVENTORY_STATE.SOLD },
    ...(options.includeArchived
      ? [{ title: 'Archived', value: INVENTORY_STATE.ARCHIVED }]
      : []),
  ]
}
